import { render } from "./InvoiceTable.vue?vue&type=template&id=28270b3e&ts=true"
import script from "./InvoiceTable.vue?vue&type=script&lang=ts"
export * from "./InvoiceTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__